<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-3">
                    <label> از تاریخ</label>
                    <Datepicker
                        simple
                        auto-submit
                        id="from-date"
                        locale="fa"
                        input-format="YYYY-MM-DD"
                        :max="today"
                        v-model="fromDate"
                        :locale-config="{
                            fa: {
                                displayFormat: 'jYYYY/jMM/jDD',
                                lang: { label: 'شمسی' }
                            }
                        }"
                    />
                </div>
                <div class="col-md-3">
                    <label> تا تاریخ</label>
                    <Datepicker
                        simple
                        auto-submit
                        id="to-date"
                        locale="fa"
                        input-format="YYYY-MM-DD"
                        :min="fromDate"
                        :max="today"
                        v-model="toDate"
                        :locale-config="{
                            fa: {
                                displayFormat: 'jYYYY/jMM/jDD',
                                lang: { label: 'شمسی' }
                            }
                        }"
                    />
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label> سازمان</label>
                        <select required class="form-control mb-3" v-model="orgenizationId">
                            <option value="">سازمان خود را انتخاب کنید</option>
                            <option
                                v-for="(org, index) in orgenizationList"
                                :key="index"
                                :value="org.orgId"
                            >
                                <div class="d-flex w-100 flex-1 flex-row justify-content-between">
                                    <span> {{ org.companyName }} </span>
                                    <span class="mx-2">
                                        - {{ numberFormat(org.balance) }} ریال</span
                                    >
                                </div>
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row" style="display: flex; justify-content: end;">
                <div class="col-md-3" style="margin-top: 29px;">
                    <button
                        class="btn btn-primary btn-block"
                        @click="submit"
                        :disabled="!fromDate || !toDate"
                    >
                        <i class="si si-magnifier"></i>
                        جستجو
                    </button>
                </div>
            </div>
            <div class="alert alert-info mt-4 mb-0" v-if="!rows.length && isSearched">
                <p class="mb-0">اطلاعاتی یافت نشد</p>
            </div>
            <hr v-if="rows.length" />
            <table class="table table-hover table-bordered mb-0" v-if="rows && rows.length">
                <thead>
                    <tr>
                        <th>نام سازمان</th>
                        <th>مبلغ (ریال)</th>
                        <th>وضعیت</th>
                        <th>تصویر فیش واریز</th>
                        <th>تاریخ</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in rows" :key="index">
                        <td>
                            {{ row.comanyName ? row.comanyName : "بدون نام" }}
                        </td>
                        <td>
                            {{
                                row.amount
                                    ? new Intl.NumberFormat("en-IR", {
                                          maximumSignificantDigits: 20
                                      }).format(row.amount)
                                    : "0"
                            }}
                        </td>
                        <td v-if="row.status == 1" class="text-warning">
                            <i class="text-warning m-1 ti-timer"></i>{{ row.statusTitle }}
                        </td>
                        <td v-else class="text-success">
                            <i class="ti-tick m-1 text-success"> </i>{{ row.statusTitle }}
                        </td>
                        <td v-if="row.imageFile" class="text-success">
                            <i class="ti-download m-1 text-success"> </i>
                            بار‌گذاری شده
                        </td>
                        <td v-else class="text-danger">
                            <i class="ti-alert text-danger  m-1"></i>
                            بار‌گذاری نشده است
                        </td>
                        <td v-if="row.insertDate">
                            {{
                                row.insertDate.replace(/\//g, "").slice(0, 4) +
                                    "/" +
                                    row.insertDate.replace(/\//g, "").slice(4, 6) +
                                    "/" +
                                    row.insertDate.replace(/\//g, "").slice(6, 8)
                            }}
                        </td>
                        <td v-else>
                            -
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="row mt-3" v-if="pages.length > 1" style="overflow-x: hidden;">
                <div class="col-12" style="overflow-x: auto;">
                    <ul class="pagination pagination-circled">
                        <li class="page-item" v-if="currentPage > 1">
                            <a class="page-link" href="#" v-on:click="currentPage--"
                                ><i class="icon ion-ios-arrow-forward"></i
                            ></a>
                        </li>
                        <li
                            :class="currentPage == page ? 'page-item active' : 'page-item'"
                            v-for="page in pages"
                            :key="page"
                        >
                            <a class="page-link" href="#" v-on:click="currentPage = page">{{
                                page
                            }}</a>
                        </li>
                        <li class="page-item" v-if="pages.length != currentPage">
                            <a class="page-link" href="#" v-on:click="currentPage++"
                                ><i class="icon ion-ios-arrow-back"></i
                            ></a>
                        </li>
                    </ul>
                </div>
            </div>
            <p v-if="rows.length" class="mt-4 mb-0">تعداد کل : {{ count }}</p>
        </div>
    </div>
</template>

<script>
import moment from "moment-jalaali";
export default {
    name: "orgenizationChargeReport",
    data() {
        return {
            showLoading: false,
            isSearched: false,
            rows: [],
            fromDate: "",
            toDate: "",
            currentPage: 1,
            pages: [1],
            perPage: 10,
            today: moment().format("jYYYY-jMM-jDD"),
            lastDeposit: 0,
            showCard: false,
            count: 0,
            orgenizationId: "",
            orgenizationList: []
        };
    },
    watch: {
        currentPage(value) {
            this.currentPage = value;
            this.getData();
        }
    },
    methods: {
        getBaseData() {
            this.$api
                .post("Organizations/OrganizationChargeWallet/GetOrganization", {})
                .then(({ data }) => {
                    if (data.status) {
                        this.orgenizationList = data.result.data;
                    }
                });
        },
        getData(excel = false) {
            this.showLoading = true;
            const postedData = {
                // fromDate: this.fromDate.replace(/\//g, ""),
                // toDate: this.toDate.replace(/\//g, ""),
                // page: this.currentPage,
                // perpage: this.perPage,
                // orgId : this.orgenizationId
            };
            this.$api
                .post(
                    "Organizations/OrganizationChargeWallet/GetCreditChargeOrganization",
                    postedData
                )
                .then(({ data }) => {
                    if (data.status) {
                        this.rows = data.result.data;
                        this.count = data.result.totalCount;
                        let calcPages = Math.ceil(this.count / this.perPage);
                        calcPages = calcPages > 1 ? calcPages : 1;
                        let pagesArray = [];
                        for (let i = 1; i <= calcPages; i++) pagesArray.push(i);
                        this.pages = pagesArray;
                    } else {
                        this.rows = [];
                    }
                })
                .finally(() => {
                    this.isSearched = true;
                    this.showLoading = false;
                    if (this.pan) {
                        this.showCard = true;
                    }
                });
        },
        downloadExcelFile() {
            this.getData(true);
        },
        submit() {
            this.getData();
        }
    },
    created() {
        this.getBaseData();
    }
};
</script>
